export function getPciVendorName(type) {
	switch (type) {
		case 0:
			return "Other";
		case 1:
			return "Rapid Comply";
		case 2:
			return "Direct Sysnet";
		default:
			break;
	}
}